import vCardsJS from 'vcards-js';
import FileSaver from 'file-saver';


let singleContact = document.querySelector('.contact-single')

if(singleContact) {
    // Get post datas
    let postObject = post.data
    // Create a new vCard
    let vCard = vCardsJS()
    // Target Export BTN
    let exportBtn = document.querySelector('#exportVCF')

    // Set properties
    // Title
    vCard.lastName = postObject.post_title

    // Images
    !!postObject.primary_image &&
    vCard.photo.attachFromUrl(postObject.primary_image.url, postObject.primary_image.extension)
    !!postObject.secondary_image &&
    vCard.logo.attachFromUrl(postObject.secondary_image.url, postObject.secondary_image.extension)

    // Phone / Email
    vCard.homePhone = postObject.contact_detail_group_contact_details_informations_group_phone
    vCard.email = postObject.contact_detail_group_contact_details_informations_group_mail

    // Location (from plan or textfield)
    if (postObject.post_main_location) {
        if(postObject.post_main_location.map_details_element_repeater_0_address_group_custom_adress){
            vCard.homeAddress.street = postObject.post_main_location.map_details_element_repeater_0_address_group_custom_adress + ' '
        }
        vCard.homeAddress.postalCode = postObject.post_main_location.map_details_element_repeater_0_address_group_zipcode_city_zip_code
        vCard.homeAddress.city = postObject.post_main_location.map_details_element_repeater_0_address_group_zipcode_city_city
        if(postObject.contact_detail_group_contact_details_location_group_additional_address) {
            vCard.homeAddress.street += postObject.contact_detail_group_contact_details_location_group_additional_address
        }
    } else {
        if(postObject.contact_detail_group_contact_details_location_group_textual_address){
            vCard.homeAddress.street = postObject.contact_detail_group_contact_details_location_group_textual_address + ' '
        }
        if(postObject.contact_detail_group_contact_details_location_group_additional_address) {
            vCard.homeAddress.street += postObject.contact_detail_group_contact_details_location_group_additional_address
        }
    }

    // Links
    if (postObject.buttons) {
        postObject.buttons.forEach(function (button) {
            if (button.link_pricto_group.pictogram == 'Lien') {
                vCard.url = button.link_pricto_group.url_link
            }
        })
    }

    // Notes (introduction + permalink)
    vCard.note = postObject.top_post_group_top_post_introduction + ' - '
    vCard.note += postObject.permalink

    const exportCard = new Blob([vCard.getFormattedString()], {encoding: "utf8", type: "text/vcard;charset=utf8"})

    exportBtn.addEventListener('click', function () {
        FileSaver.saveAs(exportCard, postObject.post_name + '.vcf')
    })
}

